import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { useAuth } from './AuthContext';
import { API_BASE_URL } from '../services/apiConfig';

const Login: React.FC = () => {
  const { user, setUser } = useAuth();

  const responseGoogle = async (response: any) => {
    try {
      const res = await axios.post(`${API_BASE_URL}/auth/google`, {
        token: response.credential,
      });
      // Store the JWT, refresh token, and user info in local storage
      localStorage.setItem('token', res.data.accessToken);
      localStorage.setItem('refreshToken', res.data.refreshToken);
      localStorage.setItem('user', JSON.stringify({
        name: res.data.name,
        email: res.data.email,
        picture: res.data.picture,
      }));
      setUser({
        name: res.data.name,
        email: res.data.email,
        picture: res.data.picture,
        role: res.data.role,
      });
      window.location.href = '/'; // Redirect to the home page or any other page after login
    } catch (error) {
      console.log(error);
    }
  };

  if (user) {
    return null; // If user is logged in, don't show the Google Login button
  }
  return (
    <GoogleLogin
      onSuccess={responseGoogle}
      onError={() => {
        console.log('Kirjautuminen epäonnistui');
      }}
    />
  );
};

export default Login;
